import { CHAT_FILE_ACCEPT_STRING } from "@v2/features/assets/constants";

export function showFileUploadDialog() {
  const input = document.createElement("input");

  input.type = "file";
  input.multiple = true;
  input.accept = CHAT_FILE_ACCEPT_STRING;
  input.click();

  return new Promise<File[] | null>((resolve) => {
    input.addEventListener("change", (e) => {
      const files = (e.currentTarget as HTMLInputElement).files;

      if (files) {
        const fileArray = Array.from(files);
        resolve(fileArray.length > 0 ? fileArray : null);
        return;
      }

      resolve(null);
    });
  });
}
